import { IName } from './model/iname';
import { Injectable } from '@angular/core';

@Injectable()
export class Utilitats {

  public isNullOrEmpty(x): boolean {
    if (x == null) {
      return true;
    }
    if (x === undefined) {
      return true;
    }
    if (typeof x === 'string' && x.trim() === '') {
      return true;
    }
    return false;
  }

  public getString(x): String {
    if (typeof x === 'string') {
        return x;
    }
    if (x['name']) {
        return x.name;
    }
    return x;
  }

  public displayName(value: IName): string {
    return value == null ? '' : value.name;
  }

}



// WEBPACK FOOTER //
// ./src/app/lib/utilitats.ts